// extracted by mini-css-extract-plugin
var _1 = "WidgetContentContainer-moduleWidgetContentContainer__HxIkI";
var _2 = "WidgetContentContainer-moduleaccordionContentWrapper__w6_wG AccordionAnimatedContent-moduleAccordionAnimatedContentWrapper__Jl0wS";
export { _1 as "WidgetContentContainer", _2 as "accordionContentWrapper" }
